export default import.meta.ROLLDOWN_FILE_URL_EIs1TVRC39nrWWZXFP69pw